// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aboutSection4 {
    background: #150924;
    color: white;
    padding: 100px;
    overflow: hidden;
}

.aboutSection4 .blog-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 65px;
    align-items: center;
}

.aboutSection4 .blog-header .heading {
    font-size: 39px;
    font-weight: 700;
    line-height: 75px;
    color: white;
    width: unset;
    padding: unset;

}

.blog-header .all-btn a {
    background-color: #06EFC5;
    color: #242424;
    text-align: center;
    font-size: 18.333px;
    font-style: normal;
    font-weight: 800;
    line-height: 13.333px;
    padding: 18px 52px;
    display: block;
    text-decoration: none;
}

.blog-header .all-btn a:hover {
    text-decoration: none !important;
}

.all-btn-mob {
    display: none;
}

.aboutSection4 .card-wrap {
    width: auto;
    /* height: 280px; */
    /* background-color: #303030; */
    /* padding: 40px 26px; */
    background: rgba(255, 255, 255, 0.05);
    margin-right: 40px;
}

.aboutSection4 .card-wrap .image img {
    width: 100%;

}

.aboutSection4 .card-wrap .card-content-wrap {
    padding: 30px 22px;
}

.aboutSection4 .card-wrap .card-content-wrap a:hover {
    text-decoration: none !important;
}

.aboutSection4 .card-wrap .card-content-wrap .title {
    color: #FFF;
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: 30.5px;
    margin-bottom: 0px;
    font-family: "Inter", sans-serif;
    text-align: left;
}

.aboutSection4 .card-wrap .card-content-wrap .blog-date {
    color: #FFF;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    opacity: 0.4;
}

.aboutSection4 .card-wrap .card-content-wrap .description {
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
}

.aboutSection4 .card-wrap .card-content-wrap .read-btn {
    color: #06EFC5;
    font-style: normal;
    font-weight: 800;
    line-height: 13.333px;
    display: flex;
    align-items: center;
}

.aboutSection4 .card-wrap .read-btn img {
    height: 24px;
}

.aboutSection4 .slick-list {
    overflow: visible;
}

.aboutSection4 .slick-prev,
.slick-next {
    top: 42%;
}

.aboutSection4 .slider-container {
    width: 100%;
    display: block;
}

.aboutSection4 .slick-prev:before {
    display: none;
}

.aboutSection4 .slick-next:before {
    display: none;
}

.aboutSection4 .slick-prev {
    z-index: 1;
    left: 0;
}

.aboutSection4 .slick-next {
    z-index: 1;
    right: 45px;
}

.blog-card-mob {
    display: none;
}

@media (max-width: 768px) {
    .aboutSection4 .blog-header {
        display: unset;
    }

    .aboutSection4 .blog-header .heading {
        font-size: 25px;
        line-height: 75px;
        text-align: center;
    }

    .blog-header .all-btn {
        display: none;
    }

    .all-btn-mob {
        display: block;
    }

    .all-btn-mob a {
        background-color: #06EFC5;
        color: #242424;
        text-align: center;
        font-size: 18.333px;
        font-style: normal;
        font-weight: 800;
        line-height: 13.333px;
        padding: 18px 52px;
        display: block;
        text-decoration: none;
    }

    .all-btn-mob a:hover {
        text-decoration: none;
    }

    .aboutSection4 {
        padding: 25px;
    }

    .aboutSection4 .slider-container {
        display: none;
    }

    .aboutSection4 .blog-header {
        margin-bottom: 24px;
    }

    .blog-card-mob {
        display: block;
    }

    .blog-card-mob .card-wrap-blog {
        width: 100%;
        background: rgba(255, 255, 255, 0.05);
        margin-bottom: 39px;
    }

    .blog-card-mob .card-wrap-blog .image img {
        width: 100%;

    }

    .blog-card-mob .card-wrap-blog .card-content-wrap {
        padding: 30px 22px;
    }

    .blog-card-mob .card-wrap-blog .card-content-wrap .title {
        color: #FFF;
        font-size: 20px;
        font-style: normal;
        font-weight: 800;
        line-height: 39px;
        margin-bottom: 0px;
        text-align: left;
        font-family: "Inter", sans-serif;
    }

    .blog-card-mob .card-wrap-blog .card-content-wrap .blog-date {
        color: #FFF;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 26px;
        opacity: 0.4;
    }

    .blog-card-mob .card-wrap-blog .card-content-wrap .description {
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 26px;
        text-align: left;
    }

    .blog-card-mob .card-wrap-blog .card-content-wrap .read-btn {
        color: #06EFC5;
        font-style: normal;
        font-weight: 800;
        line-height: 13.333px;
        display: flex;
        align-items: center;
    }

    .blog-card-mob .card-wrap-blog .read-btn img {
        height: 24px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/About/About.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,cAAc;;AAElB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,+BAA+B;IAC/B,wBAAwB;IACxB,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,OAAO;AACX;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,cAAc;QACd,kBAAkB;QAClB,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;QAChB,qBAAqB;QACrB,kBAAkB;QAClB,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,qCAAqC;QACrC,mBAAmB;IACvB;;IAEA;QACI,WAAW;;IAEf;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB,gCAAgC;IACpC;;IAEA;QACI,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,gBAAgB;QAChB,qBAAqB;QACrB,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".aboutSection4 {\n    background: #150924;\n    color: white;\n    padding: 100px;\n    overflow: hidden;\n}\n\n.aboutSection4 .blog-header {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 65px;\n    align-items: center;\n}\n\n.aboutSection4 .blog-header .heading {\n    font-size: 39px;\n    font-weight: 700;\n    line-height: 75px;\n    color: white;\n    width: unset;\n    padding: unset;\n\n}\n\n.blog-header .all-btn a {\n    background-color: #06EFC5;\n    color: #242424;\n    text-align: center;\n    font-size: 18.333px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 13.333px;\n    padding: 18px 52px;\n    display: block;\n    text-decoration: none;\n}\n\n.blog-header .all-btn a:hover {\n    text-decoration: none !important;\n}\n\n.all-btn-mob {\n    display: none;\n}\n\n.aboutSection4 .card-wrap {\n    width: auto;\n    /* height: 280px; */\n    /* background-color: #303030; */\n    /* padding: 40px 26px; */\n    background: rgba(255, 255, 255, 0.05);\n    margin-right: 40px;\n}\n\n.aboutSection4 .card-wrap .image img {\n    width: 100%;\n\n}\n\n.aboutSection4 .card-wrap .card-content-wrap {\n    padding: 30px 22px;\n}\n\n.aboutSection4 .card-wrap .card-content-wrap a:hover {\n    text-decoration: none !important;\n}\n\n.aboutSection4 .card-wrap .card-content-wrap .title {\n    color: #FFF;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 30.5px;\n    margin-bottom: 0px;\n    font-family: \"Inter\", sans-serif;\n    text-align: left;\n}\n\n.aboutSection4 .card-wrap .card-content-wrap .blog-date {\n    color: #FFF;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 26px;\n    opacity: 0.4;\n}\n\n.aboutSection4 .card-wrap .card-content-wrap .description {\n    color: #FFF;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 26px;\n}\n\n.aboutSection4 .card-wrap .card-content-wrap .read-btn {\n    color: #06EFC5;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 13.333px;\n    display: flex;\n    align-items: center;\n}\n\n.aboutSection4 .card-wrap .read-btn img {\n    height: 24px;\n}\n\n.aboutSection4 .slick-list {\n    overflow: visible;\n}\n\n.aboutSection4 .slick-prev,\n.slick-next {\n    top: 42%;\n}\n\n.aboutSection4 .slider-container {\n    width: 100%;\n    display: block;\n}\n\n.aboutSection4 .slick-prev:before {\n    display: none;\n}\n\n.aboutSection4 .slick-next:before {\n    display: none;\n}\n\n.aboutSection4 .slick-prev {\n    z-index: 1;\n    left: 0;\n}\n\n.aboutSection4 .slick-next {\n    z-index: 1;\n    right: 45px;\n}\n\n.blog-card-mob {\n    display: none;\n}\n\n@media (max-width: 768px) {\n    .aboutSection4 .blog-header {\n        display: unset;\n    }\n\n    .aboutSection4 .blog-header .heading {\n        font-size: 25px;\n        line-height: 75px;\n        text-align: center;\n    }\n\n    .blog-header .all-btn {\n        display: none;\n    }\n\n    .all-btn-mob {\n        display: block;\n    }\n\n    .all-btn-mob a {\n        background-color: #06EFC5;\n        color: #242424;\n        text-align: center;\n        font-size: 18.333px;\n        font-style: normal;\n        font-weight: 800;\n        line-height: 13.333px;\n        padding: 18px 52px;\n        display: block;\n        text-decoration: none;\n    }\n\n    .all-btn-mob a:hover {\n        text-decoration: none;\n    }\n\n    .aboutSection4 {\n        padding: 25px;\n    }\n\n    .aboutSection4 .slider-container {\n        display: none;\n    }\n\n    .aboutSection4 .blog-header {\n        margin-bottom: 24px;\n    }\n\n    .blog-card-mob {\n        display: block;\n    }\n\n    .blog-card-mob .card-wrap-blog {\n        width: 100%;\n        background: rgba(255, 255, 255, 0.05);\n        margin-bottom: 39px;\n    }\n\n    .blog-card-mob .card-wrap-blog .image img {\n        width: 100%;\n\n    }\n\n    .blog-card-mob .card-wrap-blog .card-content-wrap {\n        padding: 30px 22px;\n    }\n\n    .blog-card-mob .card-wrap-blog .card-content-wrap .title {\n        color: #FFF;\n        font-size: 20px;\n        font-style: normal;\n        font-weight: 800;\n        line-height: 39px;\n        margin-bottom: 0px;\n        text-align: left;\n        font-family: \"Inter\", sans-serif;\n    }\n\n    .blog-card-mob .card-wrap-blog .card-content-wrap .blog-date {\n        color: #FFF;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 26px;\n        opacity: 0.4;\n    }\n\n    .blog-card-mob .card-wrap-blog .card-content-wrap .description {\n        color: #FFF;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 26px;\n        text-align: left;\n    }\n\n    .blog-card-mob .card-wrap-blog .card-content-wrap .read-btn {\n        color: #06EFC5;\n        font-style: normal;\n        font-weight: 800;\n        line-height: 13.333px;\n        display: flex;\n        align-items: center;\n    }\n\n    .blog-card-mob .card-wrap-blog .read-btn img {\n        height: 24px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
